export { VolumeDiscountBanner } from './VolumeDiscountBanner';
